import { Button, Icon } from '@/components'

import { CLIENT_PORTAL_URL } from '@/constants/links'

import styles from './NavigationButtons.module.scss'

export const NavigationButtons = ({ closeMenu }) => {
  return (
    <div className={styles.buttons}>
      <Button
        tagName="a"
        size="small"
        variant="link"
        href="#ajuda"
        rel="noreferrer"
        id="header-help-button"
        onClick={() => closeMenu()}
      >
        Ajuda
      </Button>

      <Button
        tagName="a"
        size="small"
        target="_blank"
        rel="noreferrer"
        id="header-login-button"
        variant="primary"
        href={CLIENT_PORTAL_URL}
        onClick={() => closeMenu()}
      >
        <Icon name="equifax-user" size="xs" color="white" />
        Entrar
      </Button>
    </div>
  )
}
